import { render, staticRenderFns } from "./ManageSubscriptionPopup.vue?vue&type=template&id=720b9700&scoped=true&lang=pug"
import script from "./ManageSubscriptionPopup.vue?vue&type=script&lang=ts"
export * from "./ManageSubscriptionPopup.vue?vue&type=script&lang=ts"
import style0 from "./ManageSubscriptionPopup.vue?vue&type=style&index=0&id=720b9700&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720b9700",
  null
  
)

/* custom blocks */
import block0 from "./ManageSubscriptionPopup.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fcomponents%2FPopups%2FManageSubscriptionPopup.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports